import { GetServerSideProps } from 'next'
import { initializeApollo } from '~/hooks/use-apollo'
import { EmbeddableDonationForm } from '~/pages/embeddable-donation-form-old'
import {
  DonationFormDocument,
  DonationFormQuery,
  DonationFormQueryVariables,
} from '~/pages/embeddable-donation-form-old/graphql/donation-form'




 export const getServerSideProps: GetServerSideProps<any> = async context => {
   const apolloClient = initializeApollo()
 
   try {
     const { data } = await apolloClient.query<
       DonationFormQuery,
       DonationFormQueryVariables
     >({
       query: DonationFormDocument,
       variables: {
         slug: context.query['nonprofit-slug'] as string,
       },
     })
 
     return {
       props: {
         slug: context.query['nonprofit-slug'],
         color: data!.pageBySlug.color,
       },
     }
   } catch (error: any) {
     return {
       notFound: true,
     }
   }
 }

 export default EmbeddableDonationForm